import React from 'react'
import { Modal } from 'react-bootstrap'
import { MdClose, MdOutlineWidgets } from 'react-icons/md'
import { HasPermission } from '../HasPermission'
import { PermissionsList } from '@/@types/permission_list'
import { ConfigDashboardModalStyles, Content } from './styles'

type Widget = {
  id: string
  name: string
  permission?: PermissionsList
}

export const ModalConfigDashboard: React.FC<{
  onHide: () => void
  widgets: Widget[]
  widgetVisible: string[]
  onUpdateItem: (w: string) => void
}> = ({ onHide, widgets, widgetVisible, onUpdateItem }) => {
  const visibleCount = widgets.filter(w => widgetVisible.includes(w.id)).length

  const renderItem = (widget: Widget) => {
    const isOn = widgetVisible.includes(widget.id)

    return (
      <button
        type="button"
        key={widget.id}
        className={`widgets_modal__item${isOn ? ' is-on' : ''}`}
        aria-pressed={isOn}
        onClick={() => onUpdateItem(widget.id)}
      >
        <span>{widget.name}</span>
        <i className={`widgets_modal__switch${isOn ? ' is-on' : ''}`} />
      </button>
    )
  }

  return (
    <Modal show centered onHide={onHide} dialogClassName="widgets-modal">
      <ConfigDashboardModalStyles />
      <Modal.Body>
        <Content>
          <div className="widgets_modal__header">
            <MdOutlineWidgets />
            <div>
              <h5>Widgets do Dashboard</h5>
              <small>Escolha o que você quer acompanhar na home</small>
            </div>
            <button type="button" onClick={onHide} aria-label="Fechar">
              <MdClose />
            </button>
          </div>

          <div className="widgets_modal__list">
            {widgets.map(widget =>
              widget.permission ? (
                <HasPermission key={widget.id} permission={widget.permission}>
                  {renderItem(widget)}
                </HasPermission>
              ) : (
                renderItem(widget)
              )
            )}
          </div>

          <div className="widgets_modal__footer">
            <small>
              {visibleCount} de {widgets.length} em exibição
            </small>
            <button type="button" onClick={onHide}>
              Concluir
            </button>
          </div>
        </Content>
      </Modal.Body>
    </Modal>
  )
}
